import {NgModule} from '@angular/core';
import {PageContentComponent} from './page-content.component';
import {NavModule} from '../navigation/nav.module';
import {LoginPageModule} from './login/login-page.module';
import {RegisterPageModule} from './register/register-page.module';
import {PersonalDetailsPageModule} from './personal-details/personal-details-page.module';
import {EducationPageModule} from './education/education-page.module';
import {RouterModule} from '@angular/router';
import {WorkPageModule} from './work/work-page.module';
import {LicensesCertificationsPageModule} from './licenses-certifications/licenses-certifications-page.module';
import {ProfessionalLiabilityPageModule} from './liability/professional-liability-page.module';
import {ReferencesPageModule} from './references/references-page.module';
import {ReleasePageModule} from './release/release-page.module';
import {AdminPagesModule} from './admin/admin-pages.module';
import {CvPagesModule} from './cv/cv-pages.module';
import {DashboardPageModule} from './dashboard/dashboard-page.module';
import {CommonModule} from '@angular/common';
import {AccountPageModule} from './account/account-page.module';
import {ResumePagesModule} from './resume/resume-pages.module';
import {DocumentsPagesModule} from './documents/documents-pages.module';
import {VerificationSummaryModule} from './verification/verification-summary.module';
import {NotesPagesModule} from './notes/notes-pages.module';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    imports: [
        CommonModule,
        NavModule,
        RouterModule,
        LoginPageModule,
        RegisterPageModule,
        AccountPageModule,
        AdminPagesModule,
        CvPagesModule,
        ResumePagesModule,
        DashboardPageModule,
        PersonalDetailsPageModule,
        EducationPageModule,
        WorkPageModule,
        LicensesCertificationsPageModule,
        ProfessionalLiabilityPageModule,
        ReferencesPageModule,
        ReleasePageModule,
        DocumentsPagesModule,
        VerificationSummaryModule,
        NotesPagesModule,
    ],
    declarations: [PageContentComponent],
    exports: [PageContentComponent]
})
export class PageContentModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/page-content.module.ts